<template>
    <div v-loading="loading" class="alarmClass">
      <div style="height: 500px; overflow-y: scroll;overflow-x: hidden;">
       
        <el-form :model="form" ref="formRef" :rules="formRules" label-suffix=":" label-width="105px">
          <el-row :gutter="24">
          
  
            <el-col :span="12">
              <el-form-item label="护理级别" prop="name">
                
                <el-input
                clearable
                v-model="form.name"
                placeholder="自理情况"
                maxlength="100"
              ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="级别说明" prop="consumableId">
                <el-input
                clearable
                v-model="form.name"
                placeholder="自理情况"
                maxlength="100"
              ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="护理级别费用" prop="consumableId">
                <el-input
                clearable
                v-model="form.name"
                placeholder="自理情况"
                maxlength="100"
              ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="私人定制费用" prop="consumableId">
                <el-input
                clearable
                v-model="form.name"
                placeholder="自理情况"
                maxlength="100"
              ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="护理总费用" prop="consumableId">
                <el-input
                clearable
                v-model="form.name"
                placeholder="自理情况"
                maxlength="100"
              ></el-input>
              </el-form-item>
            </el-col>
           
            
         
            
            
            
          </el-row>
        </el-form>
      </div>
      
    </div>
  </template>
  <script>

  export default {
    components: {},
    model: {
    prop: 'form',
    event: 'change'
  },
    props: {
       
      row: {
        default: {},
      },
      nursinghomeId: {},
      model: {
        default: 'add',
      },
    },
    data() {
      return {
        projectList: [],
        form:{
            name:''
        },
        
        formRules: {
          name: [{ required: true, message: '物料名称不能为空', trigger: 'blur' }],
          nursinghomeId: [{ required: false, message: '项目名称不能为空', trigger: 'change' }],
       
        },
        matetialList: [],
      };
    },
    created() {
      this.initData();
    },
    mounted() {},
    watch: {},
    methods: {
  
      

      async initData() {
        
        if (this.model == 'add') {
         
        } else {
        }
      },
      saveRecord() {
       let result= false
          this.$refs['formRef'].validate((valid) => {
            console.log('子',valid)
            result =    valid

        });
          return result
       
      },
      cancleRecord() {
        this.$emit('cancle');
      },
    },
  };
  </script>
  <style scoped>
  .alarmClass {
    height: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }
  ::v-deep .el-col-8 {
    height: 54px;
  }
  </style>
  